var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
          fill: "#7fdecb"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.274 14.354a4.62 4.62 0 0 0 4.617-4.617 4.62 4.62 0 0 0-4.617-4.617 4.62 4.62 0 0 0-4.617 4.617 4.62 4.62 0 0 0 4.617 4.617zm10.378 12.8H5.669v-1.691c0-5.166 4.16-9.326 9.326-9.326h2.331c5.166 0 9.326 4.16 9.326 9.326v1.691z",
          fill: "#4868fd"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M22.171 19.063c.046-.046.091-.046.091-.091.274-.183.807-.681.869-.823l-.584-.429-.619-.378c-.594.549-.763.579-1.174 1.036-.137.183-.366.183-.731.457-.091.046-.183.137-.32.183.091-.091-.229.046-.091-.046-.549.366-.366.274-.96.503-1.143-.091-.366.366-1.783.229h.091c-.32 0-1.234.137-.411.091-.594.183-1.417-.046-.183-.046-.137-.046-.457.046-.32-.046-.137.091-1.189-.046-.777-.091-.229 0-.457-.091-.686-.137.457.091.091.091.274.137-.594-.046-.32-.183-.96-.32.823.274-1.554-.411-1.051-.366-.823-.411-.777-.366-1.097-.686-.091-.046-.549-.32-.32-.229-.137-.046-.411-.274 0-.091-.137-.091-.811-.561-.811-.699 0 0-.382.191-.714.42l-.648.459c.214.202 1.35 1.054.939 1.009.229 0 1.097.457.457.366.091.046.183.137.366.274-.137-.32.183.046.366.229-.137-.137.411-.046.091.046.137.046.274.091.411.091-.091-.046-.046.091 0 .137-.046-.046.32.137.412.183l-.137-.091c.777.274.914.32 1.783.503-.914 0-.32.137-.549.137.869.137 2.057.274 3.109.274.64-.046 1.6-.366 2.194-.32.046-.046.091-.046.229-.091-.046-.091 2.469-.869 3.246-1.783z",
          fill: "#02016f"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }